import React from "react";

function Toast({ message, title, type = "success", onClose }) {
  if (!message) {
    return null;
  }

  const palette =
    type === "success"
      ? {
          background: "linear-gradient(135deg, #166534, #16a34a)",
          border: "rgba(187, 247, 208, 0.4)",
          badge: "#dcfce7",
          text: "#f0fdf4",
        }
      : {
          background: "linear-gradient(135deg, #991b1b, #ef4444)",
          border: "rgba(254, 202, 202, 0.4)",
          badge: "#fee2e2",
          text: "#fff1f2",
        };

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        width: "min(360px, calc(100vw - 24px))",
        padding: "16px 18px",
        borderRadius: "18px",
        color: palette.text,
        background: palette.background,
        border: `1px solid ${palette.border}`,
        boxShadow: "0 20px 35px rgba(15, 23, 42, 0.18)",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "12px",
        }}
      >
        <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
          <div
            style={{
              minWidth: "36px",
              height: "36px",
              borderRadius: "12px",
              background: palette.badge,
              color: type === "success" ? "#166534" : "#991b1b",
              display: "grid",
              placeItems: "center",
              fontWeight: 700,
            }}
          >
            {type === "success" ? "OK" : "!"}
          </div>
          <div>
            <div style={{ fontWeight: 700, marginBottom: "2px" }}>
              {title || (type === "success" ? "Success" : "Action needed")}
            </div>
            <div style={{ fontSize: "14px", lineHeight: 1.5 }}>{message}</div>
          </div>
        </div>

        <button
          type="button"
          onClick={onClose}
          style={{
            border: "none",
            background: "transparent",
            color: palette.text,
            fontSize: "18px",
            lineHeight: 1,
            cursor: "pointer",
            padding: 0,
          }}
        >
          x
        </button>
      </div>
    </div>
  );
}

export default Toast;
